import { Route } from "../core/routeGuard/applicationRoutesNg.service";
import { USE_NEW_SIGN_IN_PROCESS } from "./use-new-sign-in-process";

export default class TermsOfUseController {
  constructor(private $window, private api, private DestinationService) {
    'ngInject';

    if(USE_NEW_SIGN_IN_PROCESS) {
      this.$window.location.href = Route.TERMS_OF_USE;
    }
  }

  accept() {
    this.api.useraccount.termsandconditionsrequests(true).then(() => {
      this.DestinationService.termsOfUseAccepted();
      this.DestinationService.nextDestination();
    });
  }

  decline() {
    this.api.useraccount.termsandconditionsrequests(false).then(() => {
      this.DestinationService.logout();
    });
  }
}
